import React from 'react';
import { useEffect, useState, useContext } from 'react';
import BaseCarousel from 'b2b-ui-components-lib/lib/components/baseCarousel';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './index.scss';
import { getProductDisplayName, getProductType } from 'common/constants/app.constants';

const carouselDefaultConfigs = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  slide: 'ul',
  draggable: true,
  className: 'slider',
  dotsClass: 'dots',
  //customPaging: i => <button></button>,
  responsive: [
    {
      breakpoint: 3000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    },
    {
      breakpoint: 674,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: 1
      }
    }
  ]
};

const ExploreProducts = (props: any) => {
  const { product } = props;
  const [offerList, setOfferList] = useState([]);
  const currentProduct = product || getProductType();
  const productName = getProductDisplayName(currentProduct);
  const getData = () => {
    fetch('https://assets.airtel.in/static-assets/b2b-helpme-decide-ui/json/offer.json', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        // let exploreProduct = myJson?.result?.filter((product:any)=>product.name !==productName)
        setOfferList(myJson?.result);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const redirectTo = (link: any) => {
    window.location = link;
  };

  const renderPlansCards = () => {
    return offerList.map((offer: any, index: number) => (
      <div className="banner-section">
        <div className={`dedicatedbanner  ${offer['className']}`}>
          <div className="topbanner">
            <img src={offer['bannerUrl']} className="banner-image" />
            <div className="content-box">
              {offer['name']}
              <p>{offer['discription']}</p>
              <div className="product-usage">{offer['price']}</div>
              <div className="button-box">
                <Button onClick={() => redirectTo(offer.knowMoreLink)} buttonClass="know-more" displayName={offer['knowMoreText']} />
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return <React.Fragment>{offerList && offerList.length > 0 && <BaseCarousel {...carouselDefaultConfigs}>{renderPlansCards()}</BaseCarousel>}</React.Fragment>;
};

export default ExploreProducts;
